import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'

export function DropIcon({ className, size = 20, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        d="M12 21C4.42338 21 6.26484 12.4789 11.1532 3.50683C11.5209 2.83178 12.4797 2.83111 12.8528 3.50321C17.8347 12.4766 20.5249 21 12 21Z"
        fill="currentColor"
      />
    </svg>
  )
}
